export default "__VITE_ASSET__B7NZNI7C__"